var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 60.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;stroke:#fff;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M53.62,56.09c-.38-.27-.81-.5-1.13-.83C36.88,39.67,21.28,24.07,5.68,8.47c-.31-.31-.62-.6-.9-.93-.74-.88-.71-2.01,.06-2.76,.76-.74,1.89-.74,2.76,.03,.41,.36,.79,.77,1.18,1.16,15.55,15.55,31.09,31.09,46.64,46.64,.28,.28,.49,.62,.73,.93l.39-.12v-1.29c0-16.2,0-32.41,0-48.61,0-.51,0-1.03,.11-1.52,.24-1.01,.94-1.53,1.98-1.48,1.04,.05,1.66,.65,1.83,1.67,.06,.38,.03,.78,.03,1.18,0,18.09,0,36.18,0,54.28,0,2.32-.53,2.86-2.82,2.86-18.13,0-36.26,0-54.39,0-.31,0-.63,.01-.94-.02-1.06-.1-1.77-.81-1.83-1.81-.07-1.06,.58-1.89,1.67-2.07,.46-.08,.94-.06,1.41-.06,16.13,0,32.25,0,48.38,0h1.4l.26-.43Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow_bottom.54b23892d90ac1ac123d5195f4d43fec.svg";
export { ForwardRef as ReactComponent };